import styled from 'styled-components';

import { colors } from 'global/colors';

export const Wrapper = styled.div`
  padding: 50px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ChallengeName = styled.h1`
  color: ${colors.darkBlue};
  margin: 0px 100px;
`;

export const Logo = styled.img`
  width: 200px;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
`;

export const CenteringWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
